import React from "react";
import Frequency from "./dashboard/Frequency";
import Map from "./dashboard/Map";
import { DataVizWrapper, PieChart } from "./dashboard/DataViz";
import Logo from "./Logo";
import "../styles/app.scss";
import ImbalancePrice from "./dashboard/DataViz/charts/imbalancePrice";
import SavedCarbon from "./dashboard/DataViz/charts/savedCarbon";
import BatterySoC from "./dashboard/DataViz/charts/batterySoC";
import RhinoTemperature from "./dashboard/DataViz/charts/rhinoTemperature";
import RhinoPicture from "../assets/rhino_picture_title_rounded.png";

// Color range definition
const colors = ["#FFA500", "#8AFF00", "#3CDBD3", "#6BFF00", "#FFDD00"];

// If loading component
export function loadingScreen() {
  return <div className="loading--wrapper">Loading chart</div>;
}

// Func for setting responsive size of element

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDarkMode: true,
      freq: 0,
      elWidth: 0,
      elHeight: 0,
    };
  }

  toggleDarkMode = () => {
    this.setState((prevState) => ({ isDarkMode: !prevState.isDarkMode }));
    console.log(this.state);
  };

  render() {
    const { isDarkMode } = this.state;

    return (
      <main className={`dashboard--wrapper ${isDarkMode ? "dark-mode" : ""}`}>
        <div className="col col--left">
          <div className="row row--top">
            <div className="dataviz--grid">

              <DataVizWrapper title="Imbalance and Dayahead energy prices">
                <ImbalancePrice
                    colorRange={colors}
                />
              </DataVizWrapper>

              <DataVizWrapper title="KG Carbon Dioxide saved">
                  <SavedCarbon
                      colorRange={colors}
                  />
              </DataVizWrapper>

              <div>
                <div>
                  <img width={400} height={300} src={RhinoPicture} alt="Rhino Battery" />
                </div>
              </div>

              <DataVizWrapper title="Rhino temperature">
                <RhinoTemperature
                    colorRange={colors}
                />
              </DataVizWrapper>

              <BatterySoC
                  index={0} />
              <BatterySoC
                  index={1}
              />

            </div>
          </div>
          <div className="row row--bottom">
            <h2>Help</h2>
            <ul>
              <li><strong>Imbalance prices</strong>: A quarterly price per MW. Determined by live supply and demand.</li>
              <li><strong>Dayahead prices</strong>: An hourly price per MW. Determined 24 hours ahead by expected supply and demand.</li>
              <li><strong>Rhino temperature</strong>: Temperature of the Rhino assets in °C. Charging the battery creates excess heat.</li>
              <li><strong>Frequency Netherlands</strong>: Current frequency in The Netherlands. Jumps around the value 50Hz.</li>
              <li><strong>KG Carbon Dioxide saved</strong>: This calculates the amount of carbon we have saved by (dis-)charging the Rhino battery instead of burning gas or coal.</li>
            </ul>
          </div>
        </div>
        <div className="col col--right">
          <div className="logo--toggle" onClick={this.toggleDarkMode}>
            <Logo color={true} size="large" />
          </div>
          <Frequency title="Frequency The Netherlands"/>
          <Map title="National Grid The Netherlands" />
        </div>
      </main>
    );
  }
}

export default App;
